<script>
export default {
  name: "IconLogout"
};
</script>

<template>
  <svg width="16" height="16" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg">
    <g fill="currentColor" fill-rule="nonzero">
      <path
        d="M12.852 4.498c.2-.199.518-.21.732-.035l.04.035 2.215 2.204a.54.54 0 01.137.542l-.018.05-.208-.085.208.086a.544.544 0 01-.082.136l-.036.039-2.216 2.203a.545.545 0 01-.772.001.54.54 0 01-.036-.729l.036-.038 1.285-1.278H7.53a.544.544 0 01-.543-.496l-.002-.047c0-.284.219-.517.498-.54l.047-.002h6.608l-1.286-1.278a.54.54 0 01-.035-.73l.035-.038z"
      />
      <path
        d="M10.715 0c.285 0 .52.218.543.496l.002.047v4.751a.544.544 0 01-1.09.047v-.047l-.001-4.209H2.647l3.068 1.73c.141.08.238.217.268.372l.007.052.002.049v8.882h4.177V8.878c0-.268.196-.49.453-.535l.046-.006.047-.002c.285 0 .52.218.543.496l.002.047v3.834c0 .284-.219.517-.498.54l-.047.003H5.992v2.202c0 .16-.07.31-.19.411l-.041.033-.04.026a.55.55 0 01-.493.028l-.05-.026-4.803-2.708-.013-.004a.54.54 0 01-.353-.408l-.007-.048L0 12.712V.542C0 .26.22.027.499.003L.546 0h10.169zM1.124 1.474v10.923L4.9 14.526V3.603l-3.776-2.13z"
      />
    </g>
  </svg>
</template>
